import * as Sentry from '@sentry/nextjs'
import type { z } from 'zod'

/** Caminho e mensagem de cada problema do zod, sem os valores (que podem ter dado do cliente). */
export function describeIssues(issues: readonly z.core.$ZodIssue[], prefix = ''): string[] {
    return issues.map((issue) => `${prefix}${issue.path.map(String).join('.') || '(raiz)'}: ${issue.message}`)
}

/**
 * Registra uma resposta da API fora do contrato: no console e no Sentry, com o caminho dos campos e sem os valores.
 * `error` para a resposta que não deu para usar; `warning` para o item descartado de uma lista que seguiu valendo.
 */
export function reportContractIssue(message: string, issues: string[], level: 'error' | 'warning' = 'error'): void {
    if (level === 'error') console.error(message, issues)
    else console.warn(message, issues)
    Sentry.captureMessage(message, { level, extra: { issues } })
}
